module.exports = __webpack_public_path__ + "static/media/SkipIconRed.2fd0eafe.svg";